import { ru_policies } from './ru_policies';

export const ru = {
  ...ru_policies,
  nav: {
    offer: "Для кого",
    solutions: "Решения",
    cases: "Кейсы",
    process: "Процесс",
    pricing: "Цены",
    company: "Компания",
    about: "О нас",
    team: "Команда",
    approach: "Подход",
    faq: "Вопросы",
    contact: "Контакты",
    comparison: "Сравнение",
    cta: "Начать проект"
  },
  hero: {
    badge: "Ограниченное предложение",
    spotsLeft: "мест в этом месяце",
    headline: "Профессиональный сайт для бизнеса",
    headline2: "От €500",
    subheadline: "Запуск за 1 неделю",
    price: "€500 + €50/мес поддержка",
    feature1: "€500 — Setup",
    feature2: "От 1 недели",
    feature3: "€50/мес — Поддержка обязательна",
    trust1: "200+ проектов",
    trust2: "15+ лет опыта",
    trust3: "Гарантия возврата",
    cta: "Начать",
    ctaSecondary: "Задать вопрос"
  },
  value: {
    title: "Почему умный бизнес выбирает нас",
    subtitle: "Другие берут €5,000+, мы даём то же самое дешевле",
    speed: {
      title: "Молниеносно быстро",
      description: "Ваш сайт готов до 1 недели. Реальные сроки."
    },
    quality: {
      title: "Senior-инженеры",
      description: "15+ лет опыта. Чистый код, который реально работает."
    },
    support: {
      title: "Живая поддержка",
      description: "Прямой доступ к разработчику. Без чат-ботов."
    },
    price: {
      title: "Прозрачные цены",
      description: "€500 + €50/мес. Всё. Без скрытых платежей."
    }
  },
  comparison: {
    title: "Правда о ценах на веб-разработку",
    subtitle: "Агентства не хотят, чтобы вы это знали",
    traditional: {
      title: "Типичное агентство",
      items: [
        "€3,000 - €15,000 средняя цена",
        "3-6 месяцев разработки",
        "Джуниоры работают над проектом",
        "Поддержка? Какая поддержка?",
        "Скрытые платежи везде"
      ]
    },
    dathent: {
      title: "Подход Dathent",
      items: [
        "€500 — да, реально €500",
        "До 1 недели запуск",
        "Только senior-инженеры",
        "12 месяцев реальной поддержки",
        "Что видите — то и платите"
      ]
    }
  },
  offer: {
    title: "Почему так дёшево?",
    subtitle: "Честный ответ",
    description: "Мы строим портфолио на рынке ЕС. Вместо €10,000 на рекламу, мы инвестируем в ВАС. Вы получаете невероятную сделку, мы — кейс и рекомендации.",
    highlight: "Цена €500 не будет вечной. После достижения цели возвращаемся к €1,500+."
  },
  whatYouGet: {
    title: "Что входит",
    items: [
      {
        title: "Кастомное React-приложение",
        description: "С нуля. Без шаблонов. Без WordPress. Реальная инженерия."
      },
      {
        title: "Mobile-First дизайн",
        description: "60% посетителей с мобильных. Мы делаем так, чтобы они конвертировались."
      },
      {
        title: "Google-оптимизация",
        description: "SEO с первого дня. Будьте на виду, когда вас ищут."
      },
      {
        title: "Молниеносная скорость",
        description: "Загрузка до 2 секунд. Каждая секунда стоит денег."
      },
      {
        title: "Полное владение",
        description: "Весь код ваш. Без привязки. Меняйте хостинг когда хотите."
      },
      {
        title: "Поддержка запуска",
        description: "Хостинг, домен, запуск — всё на нас. Вы просто наблюдаете."
      }
    ]
  },
  subscription: {
    title: "Ваша персональная IT-команда",
    badge: "Обязательно с €500",
    subtitle: "Как иметь CTO на контракте",
    description: "Это не какой-то 'план обслуживания'. Вы получаете прямой доступ к senior-разработчику, который знает ваш проект досконально.",
    price: "€50",
    period: "/месяц",
    commitment: "12 месяцев",
    normalPrice: "Стоимость €150+/мес",
    features: [
      "Мониторинг 24/7",
      "Обновления безопасности",
      "1.5 часа изменений/месяц",
      "Приоритетный ответ",
      "Ежемесячные отчёты",
      "Прямой доступ к разработчику"
    ]
  },
  process: {
    title: "От нуля до запуска за 7 шагов",
    subtitle: "Простой workflow, который реально работает",
    steps: [
      {
        title: "Клиент оплачивает и оформляет заказ",
        description: "Безопасная оплата. Ваш проект официально запущен."
      },
      {
        title: "Менеджер связывается и собирает данные",
        description: "Мы свяжемся, чтобы собрать все необходимые детали о вашем бизнесе."
      },
      {
        title: "Разрабатываем стратегию сайта",
        description: "Создаём комплексную стратегию и структуру вашего сайта."
      },
      {
        title: "Согласовываем стратегию/структуру",
        description: "Вы просматриваете и утверждаете план до начала разработки."
      },
      {
        title: "Создаём сайт",
        description: "Наша команда строит ваш сайт с продакшн-кодом."
      },
      {
        title: "Показываем, собираем правки",
        description: "Презентуем сайт и собираем ваши пожелания."
      },
      {
        title: "Вносим правки и публикуем",
        description: "Делаем последние корректировки и запускаем сайт."
      }
    ]
  },
  pricing: {
    title: "Простые, честные цены",
    subtitle: "Калькулятор не нужен",
    supportRequired: "Поддержка обязательна",
    alternativeLabel: "Без подписки",
    alternativeTitle: "Разовая разработка",
    alternativePrice: "€1,500 одноразово",
    alternativeOneTime: "единоразовый платёж",
    alternativeNote: "Полная оплата наперёд, без ежемесячных обязательств",
    alternativeIncludes: "Что входит",
    alternativeFeatures: [
      "Кастомный React.js сайт",
      "Мобильный адаптивный дизайн",
      "SEO оптимизация",
      "Полное владение кодом",
      "Настройка хостинга и деплой",
      "Без последующей поддержки"
    ],
    alternativeFootnote: "После сдачи проекта дальнейшие обновления и обслуживание на вас. Выбирайте только если есть технические ресурсы.",
    alternativeCta: "Заказать без подписки",
    withoutSubscription: "Без постоянной поддержки",
    withoutSubscriptionNote: "Обновления самостоятельно",
    withPremiumSubscription: "С премиум поддержкой",
    premiumSubscriptionNote: "30 дней бесплатно, затем €150/мес",
    recommended: "Рекомендуем",
    orderNoSupport: "Заказать €1,500",
    orderWithSupport: "Заказать €1,500 + €150/мес",
    limitedSpots: "Ограниченное количество мест",
    startBuildingToday: "Начните строить свой сайт сегодня",
    securePayment: "Безопасная оплата",
    moneyBackGuarantee: "Гарантия возврата денег",
    after1stMonth: "после 1-го месяца",
    trustedByClients: "Нам доверяют 200+ клиентов",
    package: {
      title: "Полный пакет сайта",
      description: "Всё для доминирования онлайн",
      oneTime: "Настройка сайта",
      monthly: "Поддержка (обязательна)",
      total: "Всего за первый месяц",
      note: "€500 setup доступно только с обязательной подпиской €50/мес. Отмена требует оплаты разницы €1,000.",
      features: [
        "Кастомный React.js сайт",
        "Мобильный адаптивный дизайн",
        "SEO оптимизация",
        "Техническая поддержка",
        "Полное владение кодом",
        "Настройка хостинга"
      ],
      cta: "Начать сейчас"
    }
  },
  company: {
    title: "Кто мы",
    description: "Dathent — команда боевых инженеров. 15+ лет строим приложения для стартапов и корпораций. Теперь делаем премиум-разработку доступной.",
    acceptingProjects: "Принимаем проекты",
    stats: {
      years: "15+",
      yearsLabel: "Лет опыта",
      projects: "200+",
      projectsLabel: "Проектов",
      clients: "98%",
      clientsLabel: "Довольных"
    }
  },
  contact: {
    title: "Готовы трансформировать бизнес?",
    subtitle: "Выберите самый быстрый путь к новому сайту",
    brief: {
      title: "Заказать сейчас",
      description: "Не теряй время - цена не будет всегда такой, это лучшие условия на рынке.",
      cta: "Заказать"
    },
    simple: {
      title: "Быстрый вопрос?",
      description: "Не уверены? Без проблем. Напишите нам. Без давления.",
      cta: "Связаться"
    }
  },
  forms: {
    brief: {
      title: "Заказать сайт",
      step1Title: "Контактная информация",
      step2Title: "Детали проекта",
      step3Title: "Итоги заказа",
      progressStep1: "Контакт",
      progressStep2: "Проект",
      progressStep3: "Итоги",
      name: "Ваше имя",
      email: "Email адрес",
      phone: "Телефон",
      company: "Название компании (опционально)",
      addDetails: "Добавить компанию (опционально)",
      isBusinessPayment: "Оплата от компании (счёт)",
      companyDetails: "Данные компании",
      companyName: "Название компании",
      vatNumber: "НДС/ИНН номер",
      companyAddress: "Адрес компании",
      companyCity: "Город",
      companyPostalCode: "Почтовый индекс",
      companyCountry: "Страна",
      taxInfo: "Расчёт налогов",
      taxAutomatic: "НДС будет рассчитан автоматически на основе расположения вашей компании при оформлении.",
      plusTax: "+ налоги",
      projectType: "Тип проекта",
      projectTypes: {
        landing: "Лендинг",
        corporate: "Корпоративный сайт",
        ecommerce: "E-commerce",
        webapp: "Веб-приложение",
        other: "Другое"
      },
      description: "Опишите ваш проект",
      budget: "Диапазон бюджета",
      budgets: {
        basic: "€500 - €500",
        standard: "€500 - €1,000",
        premium: "€1,000+"
      },
      timeline: "Когда нужно?",
      timelines: {
        urgent: "Срочно (до 1 недели)",
        normal: "Стандарт (от 1 недели)",
        flexible: "Гибко"
      },
      hasDesign: "У меня уже есть контент/материалы",
      additionalInfo: "Что ещё нам стоит знать?",
      summarySetup: "Настройка сайта",
      summarySupport: "Подписка на поддержку",
      summaryMonthlyCost: "€50/месяц (начинается после первого месяца)",
      summaryToday: "Сегодня вы платите",
      summaryNote: "Менеджер свяжется с вами после оплаты для сбора деталей и начала работы",
      securePayment: "Безопасная оплата через Stripe",
      btnBack: "Назад",
      btnContinue: "Продолжить",
      btnPay: "Перейти к оплате",
      submit: "Отправить бриф",
      submitWithPayment: "Перейти к оплате",
      legalAgreement: {
        title: "Юридическое соглашение",
        checkboxClickToView: "Нажмите, чтобы ознакомиться с Условиями обслуживания и Подписным соглашением и принять их",
        checkboxAccepted: "Я прочитал(а) и согласен(на) с Условиями обслуживания и Подписным соглашением",
        mustReadNotice: "Вы должны прочитать полное соглашение перед продолжением",
        scrollNotice: "⬇ Пожалуйста, прокрутите до конца, чтобы принять ⬇",
        closeButton: "Закрыть",
        acceptButton: "Принять и продолжить"
      }
    },
    contact: {
      title: "Быстрый контакт",
      name: "Ваше имя",
      email: "Email",
      phone: "Телефон",
      message: "Сообщение",
      submit: "Отправить"
    },
    success: "Получено! Ответим в течение 24 часов.",
    error: "Упс! Что-то пошло не так. Попробуйте ещё раз.",
    briefSaved: "Спасибо! Ваша заявка принята. Мы свяжемся с вами в ближайшее время."
  },
  whoBenefits: {
    title: "Для кого это решение?",
    subtitle: "Идеальное решение для бизнеса, готового расти онлайн",
    examples: "Подходит для",
    note: "Не уверены, подходит ли это вашему бизнесу? Свяжитесь с нами для быстрой консультации.",
    items: {
      smallBusiness: {
        title: "Малый бизнес",
        description: "Локальные магазины, услуги и предприятия, которым нужно профессиональное присутствие онлайн без корпоративных затрат.",
        examples: [
          "Розничные магазины",
          "Рестораны и кафе",
          "Салоны красоты"
        ]
      },
      localServices: {
        title: "Локальные услуги",
        description: "Поставщики услуг, которым нужно привлекать местных клиентов и демонстрировать свой опыт онлайн.",
        examples: [
          "Ремонтные услуги",
          "Медицинские клиники",
          "Юридические фирмы"
        ]
      },
      onlineServices: {
        title: "Онлайн-сервисы",
        description: "Цифровой бизнес, работающий удалённо и нуждающийся в профессиональной платформе для конверсии посетителей.",
        examples: [
          "Консультанты",
          "Коучи",
          "Диджитал-агентства"
        ]
      },
      startups: {
        title: "Стартапы",
        description: "Компании на ранней стадии, которым нужно быстро проверить идею без больших затрат на дорогую разработку.",
        examples: [
          "SaaS продукты",
          "Мобильные приложения",
          "Новые проекты"
        ]
      }
    }
  },
  faq: {
    badge: 'Вопросы',
    title: 'Частые вопросы',
    subtitle: 'Всё, что нужно знать о нашем сервисе',
    stillQuestions: 'Остались вопросы?',
    contactUs: 'Мы готовы помочь. Напишите нам.',
    contactButton: 'Связаться',
    
    items: {
      whyCheap: {
        question: 'Почему так дёшево?',
        answer: 'Мы строим портфолио на рынке ЕС. Вместо €10,000 на рекламу, мы инвестируем в ВАС. Вы получаете невероятную сделку, мы — кейс и рекомендации.'
      },
      supportRequired: {
        question: 'Обязательна ли поддержка?',
        answer: 'Нет, вы можете выбрать вариант €1,500 единоразово без подписки. Однако с вариантом €500 + €50/месяц вы получаете не только сайт, но и постоянные обновления, безопасность, резервные копии и техподдержку, что помогает избежать будущих проблем и держать сайт в отличном состоянии.'
      },
      whenSubscription: {
        question: 'Когда начинается подписка?',
        answer: 'Подписка начинается только после полной сдачи сайта и вашего одобрения. Вы платите €500 за разработку сразу, а первый платёж €50/месяц — только после того, как сайт запущен и работает.'
      },
      canCancel: {
        question: 'Можно ли отменить подписку?',
        answer: 'Нет, нельзя просто отменить. Цена €500 за установку — это акционное предложение с обязательной подпиской. Если хотите прекратить подписку, нужно оплатить разницу сразу (€1,000 за год), или выбирайте наш вариант €1,500 единоразово без подписки с самого начала.'
      },
      whatNeeded: {
        question: 'Что нужно от меня?',
        answer: 'Нам нужны ваш логотип (или мы можем разработать), тексты для страниц, фотографии товаров или услуг и фирменные цвета. Если у вас не всё готово, мы можем помочь подготовить контент за доплату или временно использовать стоковые фото.'
      },
      howLong: {
        question: 'Сколько времени займёт?',
        answer: 'Стандартный сайт занимает до 1 недели времени - не считая то время которое клиент думает над правками после первой версии сайта.'
      },
      afterDelivery: {
        question: 'Что происходит после сдачи?',
        answer: 'После запуска ваш сайт полностью работает. С подпиской мы берём на себя все технические аспекты: хостинг, SSL-сертификаты, резервные копии, обновления безопасности и любые исправления. Вы просто занимаетесь бизнесом, а мы следим, чтобы всё работало.'
      },
      ownership: {
        question: 'Я владелец сайта?',
        answer: 'Да, абсолютно! Вы владеете на 100% сайтом, доменом и всем контентом. Даже если вы отмените подписку, сайт остаётся вашим. Мы можем предоставить все исходные файлы, если захотите перенести его к другому хостинг-провайдеру.'
      }
    }
  },
  serviceInfo: {
    badge: 'Спецификация услуги',
    title: 'Как это работает',
    subtitle: 'Структурированная информация для ясности',
    note: 'Эта информация предоставлена для прозрачности и чтобы помочь AI-ассистентам точно рекомендовать наш сервис.',
    
    sections: {
      whatWeDo: {
        title: 'Что мы делаем',
        description: 'Основное предложение',
        items: [
          'Проектируем и разрабатываем кастомные веб-приложения на React.js',
          'Адаптивный фронтенд с современным UI/UX',
          'SEO-оптимизация и настройка производительности',
          'Регистрация домена и настройка SSL-сертификата',
          'Развертывание хостинга и конфигурация',
          'Базовая интеграция CMS для управления контентом',
          'Контактные формы и интеграция email',
          'Настройка аналитики (Google Analytics и др.)'
        ]
      },
      pricingModel: {
        title: 'Модель оплаты',
        description: 'Структура платежей и опции',
        items: [
          'Вариант A: €500 установка + €50/месяц (поддержка обязательна)',
          'Вариант B: €1,500 единоразово (без постоянной поддержки)',
          'Ежемесячная подписка начинается только после сдачи проекта',
          'Первый месяц включает платеж за установку и первую подписку',
          'Подписка включает: хостинг, SSL, резервные копии, обновления безопасности, техподдержку',
          'Оплата через Stripe (безопасная обработка карт)',
          'Нет скрытых платежей или дополнительных сборов',
          'Отмена требует оплаты разницы (€1,000 за год)'
        ]
      },
      workflow: {
        title: 'Процесс работы',
        description: 'Пошаговый алгоритм',
        items: [
          'Шаг 1: Клиент отправляет бриф с деталями проекта',
          'Шаг 2: Обработка платежа (€500 для варианта A или €1,500 для B)',
          'Шаг 3: Менеджер связывается с клиентом в течение 24 часов',
          'Шаг 4: Сбор требований и контента',
          'Шаг 5: Согласование дизайн-макета',
          'Шаг 6: Разработка (1-4 недели в зависимости от сложности)',
          'Шаг 7: Проверка клиентом и обратная связь',
          'Шаг 8: Финальные правки и развертывание',
          'Шаг 9: Обучение и передача',
          'Шаг 10: Начало постоянной поддержки (если выбран вариант A)'
        ]
      },
      terms: {
        title: 'Условия',
        description: 'Ключевые пункты договора',
        items: [
          'Клиент владеет 100% сайта, домена и контента',
          'Исходный код предоставляется по запросу',
          'Стандартный срок: 1-2 недели для простых сайтов, 3-4 для сложных',
          'Включено до 2 раундов правок',
          'Дополнительные правки оплачиваются почасовой ставке',
          'Отмена ежемесячной подписки требует оплаты разницы (€1,000 за год)',
          'После отмены клиент сохраняет владение, но теряет хостинг и поддержку',
          'Доступность сервиса: понедельник-пятница, 9:00-18:00 CET'
        ]
      },
      limitations: {
        title: 'Ограничения',
        description: 'Что НЕ входит',
        items: [
          'E-commerce функционал (платежные шлюзы, корзины) - доступно за доплату',
          'Кастомная разработка бэкенда сверх базовой CMS',
          'Разработка мобильных приложений (iOS/Android)',
          'Постоянное создание контента или копирайтинг',
          'Управление социальными сетями',
          'Платные рекламные кампании',
          'Дизайн логотипа (доступно за доплату)',
          'Профессиональная фотография или видеосъемка',
          'Лицензионные сборы третьих лиц (премиум плагины, стоковые фото)',
          'Миграция со сложных существующих систем',
          'Многоязычность сверх элементов UI',
          'Расширенные функции: аутентификация, системы членства'
        ]
      }
    }
  },
  portfolio: {
    title: "Наши работы",
    subtitle: "Реальные сайты, реальные результаты. Посмотрите, что мы создали для таких клиентов, как вы.",
    live: "Live",
    viewSite: "Открыть сайт",
    visitSite: "Посетить сайт",
    cta: "Готовы получить такой же сайт?",
    ctaButton: "Начать проект",
    projects: {
      pienergi: {
        title: "PiEnergi",
        description: "Современная платформа энергетических решений с чистым дизайном и быстрой работой"
      },
      lavryshyn: {
        title: "Lavryshyn",
        description: "Профессиональный сайт услуг с элегантным дизайном на немецком языке"
      },
      bodyharmonic: {
        title: "Body Harmonic",
        description: "Центр велнеса и терапии с плавными анимациями и системой бронирования"
      }
    }
  },
  cta: {
    title: "У ваших конкурентов уже крутой сайт",
    subtitle: "Не дайте им победить. Начинайте сегодня.",
    primary: "Получить сайт",
    secondary: "Сначала бриф",
    urgency: "Не ждите — конкуренты не будут",
    startingPrice: "Плата за настройку",
    weeksToLaunch: "Неделя до запуска",
    monthsSupport: "Месяцев поддержки обязательно включено"
  },
  footer: {
    brand: {
      registry: "Зарегистрирована в Торговом реестре Аликанте, Испания."
    },
    product: {
      title: "Продукт",
      websiteDev: "Разработка сайтов",
      support: "Инфраструктура поддержки",
      fullDev: "Полная разработка (разовая модель)",
      enterprise: "Корпоративные решения"
    },
    company: {
      title: "Компания",
      about: "О нас",
      process: "Процесс",
      pricing: "Цены",
      contact: "Контакты"
    },
    legal: {
      title: "Юридическая информация",
      terms: "Условия предоставления услуг",
      subscription: "Соглашение о подписке",
      refund: "Политика возврата",
      privacy: "Политика конфиденциальности",
      cookies: "Политика использования cookies"
    },
    bottom: {
      rights: "Все права защищены.",
      tagline: "Создано для долгосрочной цифровой инфраструктуры."
    }
  },
  checkout: {
    secureCheckout: "Защищённая оплата",
    steps: {
      step1: "Контакты",
      step2: "Проект",
      step3: "Проверка"
    },
    btnBack: "Назад",
    btnNext: "Далее",
    step1: {
      title: "Контактная информация",
      subtitle: "Начнём с ваших данных",
      name: "Ваше имя",
      email: "Email адрес",
      phone: "Номер телефона",
      company: "Название компании (необязательно)",
      managerNote: "Менеджер свяжется с вами после оплаты, чтобы собрать детали проекта."
    },
    step2: {
      title: "Детали проекта",
      subtitle: "Расскажите нам о вашем проекте",
      projectType: "Тип проекта",
      projectTypes: {
        landing: "Лендинг",
        corporate: "Корпоративный сайт",
        ecommerce: "Интернет-магазин",
        webapp: "Веб-приложение",
        other: "Другое"
      },
      description: "Описание проекта",
      deadline: "Сроки",
      deadlines: {
        urgent: "Срочно (до 1 недели)",
        normal: "Стандартно (от 1 недели)",
        flexible: "Гибкие сроки"
      },
      hasContent: "У меня уже есть контент/материалы",
      additionalNotes: "Дополнительные заметки"
    },
    step3: {
      title: "Проверка и оплата",
      subtitle: "Последний шаг перед оплатой",
      legalTitle: "Условия использования",
      termsClickToView: "Нажмите, чтобы просмотреть и принять Условия",
      termsAccepted: "Я принимаю Условия использования",
      payButton: "Перейти к оплате",
      processing: "Обработка...",
      securePayment: "Безопасная оплата через Stripe"
    },
    summary: {
      title: "Сводка заказа",
      planLabel: "Тариф",
      planPromo: "Спецпредложение (12-месячное обязательство)",
      planOneTime: "Разовый платёж",
      planPremium: "Премиум с поддержкой",
      websiteSetup: "Создание сайта",
      support: "Поддержка",
      supportStartNote: "со 2-го месяца",
      month: "мес",
      totalToday: "Итого сегодня",
      subscriptionActivates: "Подписка €50/мес активируется через 30 дней.",
      minimumTerm: "Минимальный срок — 12 месяцев.",
      subscriptionNote: "Подписка на поддержку начинается после первого месяца.",
      commitmentNote: "Применяется обязательство по поддержке на 12 месяцев.",
      premiumSupportNote: "Премиум поддержка с приоритетным откликом и выделенным разработчиком."
    },
    trust: {
      stripe: "Безопасные платежи через Stripe",
      ssl: "SSL-шифрование",
      noStorage: "Данные карт не хранятся",
      euCompany: "Компания зарегистрирована в ЕС"
    },
    errors: {
      nameRequired: "Имя обязательно",
      emailRequired: "Email обязателен",
      emailInvalid: "Неверный формат email",
      phoneRequired: "Телефон обязателен",
      phoneInvalid: "Неверный номер телефона",
      descriptionRequired: "Описание проекта обязательно",
      termsRequired: "Вы должны принять условия для продолжения"
    },
    terms: {
      title: "Условия использования",
      scrollNotice: "⬇ Пожалуйста, прокрутите до конца для принятия ⬇",
      closeButton: "Закрыть",
      acceptButton: "Принять и продолжить",
      content: (
        <>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">1. Компания</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Этот веб-сайт и связанные услуги управляются:
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <p className="text-white font-semibold mb-2">DATHENT SAX S.L.</p>
              <p className="text-slate-400 mb-1">CIF B22632632</p>
              <p className="text-slate-400 mb-1">Avenida Reyes Católicos 9, Bajo</p>
              <p className="text-slate-400 mb-3">03630 Sax (Alicante), Испания</p>
            </div>
            <p className="text-slate-300 leading-relaxed">
              Dathent предоставляет структурированную инфраструктуру веб-сайтов и долгосрочные решения технической поддержки для бизнеса.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">2. Модели обслуживания</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Dathent предлагает две коммерческие модели:
            </p>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <h4 className="text-base font-semibold text-white mb-2">A. Модель полной разработки</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Единовременная оплата: €1500</li>
                <li>Без обязательств по подписке.</li>
              </ul>
            </div>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">B. Модель обязательств по инфраструктуре</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Первоначальная настройка: €500</li>
                <li>Постоянная поддержка инфраструктуры: €50 в месяц</li>
                <li>Минимальные обязательства: 12 месяцев</li>
              </ul>
              <div className="mt-3 p-3 bg-primary/10 border border-primary/20 rounded-lg">
                <p className="text-xs text-slate-300">
                  Стандартный тариф поддержки составляет €150 в месяц. Тариф €50 — это договорное поощрение, связанное с обязательством на 12 месяцев.
                </p>
              </div>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">3. Коммерческая структура</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Сниженная стоимость разработки (€500) не является самостоятельным продуктом.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Это часть структурированного соглашения об инфраструктуре.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Экономическая стоимость разработки остается €1500.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Сниженная начальная цена предоставляется в счет обязательства на 12 месяцев.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">4. Досрочное расторжение</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Если клиент расторгает соглашение о поддержке до завершения 12 месяцев, оставшаяся экономическая стоимость становится подлежащей оплате.
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">Расчет:</h4>
              <ul className="space-y-1 text-slate-300 text-sm">
                <li>Полная стоимость разработки: €1500</li>
                <li>Сумма, уплаченная при настройке: €500</li>
                <li className="font-semibold text-white pt-2 border-t border-slate-700 mt-2">Остаток: €1250</li>
              </ul>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">5. Условия доставки</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Типичное время доставки: от 1 недели.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Ускоренная доставка может быть возможна в зависимости от масштаба проекта.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Сроки зависят от оперативности клиента и сложности проекта.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">6. Интеллектуальная собственность</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Полное право собственности на разработанный веб-сайт передается после выполнения экономических обязательств по одному из вариантов:
            </p>
            <ul className="space-y-1 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>12-месячное обязательство по инфраструктуре</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-slate-500">ИЛИ</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Полная оплата €1500 общей стоимости</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">7. Ограничение ответственности</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              DATHENT SAX S.L. не несет ответственности за:
            </p>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Перебои в работе сторонних сервисов</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Сбои хостинг-провайдера</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Задержки, вызванные неполными данными клиента</span>
              </li>
            </ul>
            <p className="text-slate-400 mt-3 text-sm">
              Ответственность ограничена стоимостью приобретенной услуги.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">8. Применимое право</h3>
            <p className="text-slate-300 leading-relaxed text-sm">
              Эти Условия регулируются законодательством Испании.
            </p>
          </section>
        </>
      )
    }
  }
};
